import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const PlayCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm2.841 8.284-4.333 2.667a.336.336 0 0 1-.337.007.334.334 0 0 1-.171-.291V5.334a.334.334 0 0 1 .508-.284l4.334 2.666a.333.333 0 0 1 0 .568z"
        fillRule="nonzero"
      />
    </svg>
  );
};

PlayCircle.displayName = 'PlayCircle';
